import React from "react";
import "../../styles/Card.css";
import Tag from "../Tag/Tag";

const Card = (props) => {
    return(
        <div className="card">
            <h1>{props.nomeProjeto}</h1>
            <p>{props.descricao}</p>
            <div className="tags-container">
                {Array.from({ length: props.numTag }).map((_, index) => (
                    <Tag 
                        key={index}
                        text={props.tagTexts[index]} 
                        color={props.tagColors[index]}
                    />
                ))}
            </div>
            <a href={props.link}>{props.linkmessage}</a>
        </div>
    );
}

export default Card;